import { groupBy, each } from "underscore";

export function groupAndSortStrikes(strikes: any) {
  const groups = groupBy(strikes, (strike) => {
    if (strike && strike?.s) {
      return strike?.s?.r;
    }
    return false;
  });

  const groupArray: any = [];

  each(groups, (group) => {
    const newGroup = {
      key: group[0]?.s?.r,
      data: group,
    };

    groupArray.push(newGroup);
  });

  return sortStrikes(groupArray);
}

export const sortStrikes = (groupedStrikes: any) =>
  sortValues(groupedStrikes, (a = { key: 0 }, b = { key: 0 }) =>
    b.key < a.key ? 1 : -1,
  );

export const sortValues = (arr: any[], comparator: any) => arr.sort(comparator);

export const monthMap: Record<string, number> = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11,
};

export function extractBaseText(str: string) {
  // remove trailing month and year from string and returning contract basename
  return str
    .replace(/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\d{2}$/i, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function extractDate(str: string) {
  const match = str.match(
    /(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)(\d{2})$/i,
  );
  if (!match) return null;
  const [, month, year] = match;
  return new Date(2000 + Number(year), monthMap[month.toLowerCase()]);
}

export const sortContractsByNameFollowUpWithExpiry = (data: any) => {
  data.sort((a: any, b: any) => {
    const descA = a.TermStructureDescription || "";
    const descB = b.TermStructureDescription || "";
    // Alphabetically by base text
    const baseA = extractBaseText(descA);
    const baseB = extractBaseText(descB);
    const baseCompare = baseA.localeCompare(baseB);
    if (baseCompare !== 0) return baseCompare;
    // Date comparison
    const dateA: any = extractDate(descA);
    const dateB: any = extractDate(descB);
    if (!dateA) return 1;
    if (!dateB) return -1;
    return dateA - dateB;
  });
  return data;
};
